import { createBrowserHistory } from 'history';
import { createElement } from 'react';
import { hydrate, render } from 'react-dom';
import { init as sentryInit, captureException } from '@sentry/browser';
import GraphQLClient from './adapter/GraphQLClient';
import { from, ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { RestLink } from 'apollo-link-rest';
import { cache } from './cache';
import { commands } from './operations/commands';
import Root from './views/Root';
var main = function () {
    var config = window.__config__;
    var history = createBrowserHistory();
    // Adapter
    var graphqlClient = new GraphQLClient({
        endpointUrl: config.APP_API_BASE_URL + "/graphql",
    });
    var idGraphqlClient = new GraphQLClient({
        endpointUrl: config.CORE_API_BASE_URL + "/graphql",
    });
    var customFetch = function (uri, options) {
        var operationName = JSON.parse(options.body).operationName;
        return fetch(uri + "/" + operationName, options);
    };
    sentryInit({
        dsn: config.SENTRY_DSN,
        environment: location.hostname === 'dataplatform-local.pbcd.net' ? 'local' : config.STAGE,
        release: '1',
    });
    var errorLink = onError(function (_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError;
        if (graphQLErrors)
            graphQLErrors.map(function (error) {
                captureException(error);
                commands.setErrors(error);
            });
        if (networkError) {
            captureException(networkError);
            commands.setErrors(networkError);
        }
    });
    var fileSerializer = function (data, headers) {
        var formData = new FormData();
        formData.append('file', data);
        return { body: formData, headers: headers };
    };
    var restLink = new RestLink({
        endpoints: { id: config.CORE_API_BASE_URL },
        uri: config.APP_API_BASE_URL,
        credentials: 'include',
        bodySerializers: {
            fileSerializer: fileSerializer,
        },
    });
    var apolloClient = new ApolloClient({
        link: from([
            restLink,
            errorLink,
            new HttpLink({
                uri: config.APP_API_BASE_URL + "/graphql",
                credentials: 'include',
                fetch: customFetch,
            }),
        ]),
        cache: cache,
    });
    var idApolloClient = new ApolloClient({
        link: new HttpLink({
            uri: config.CORE_API_BASE_URL + "/graphql",
            credentials: 'include',
            fetch: customFetch,
        }),
        cache: new InMemoryCache(),
    });
    var container = document.getElementById('app');
    var isRendered = false;
    var update = function () {
        var element = createElement(Root, { history: history, config: config, apolloClient: apolloClient, idApolloClient: idApolloClient });
        if (!isRendered) {
            isRendered = true;
            render(element, container);
            return;
        }
        hydrate(element, container);
    };
    update();
};
window.document.addEventListener('DOMContentLoaded', main);
